export default __webpack_public_path__ + "static/media/colorSensor.8bef643a.svg";